// import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";
// import { Fancybox } from "@fancyapps/ui";
// Swiper.use([Navigation, Pagination, Scrollbar]);

import "./functions/burger";
